import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { QQShare } from '@ifeng-fe/three_terminal/es/mobile/qqShare/dynamic';
import { area } from '@src/utils/area';

const SecondShare = ({ languages }) => {
    const [isUpdate, setIsUpdate] = useState(true);
    const qqShareConfig = {
        title: area[languages].share.title,
        img: area[languages].share.img,
        desc: area[languages].share.desc,
        appType: 'newsApp',
        cb: () => {},
    };

    useEffect(() => {
        setIsUpdate(false);

        setTimeout(() => {
            setIsUpdate(true);
        }, 500);
    }, [languages]);

    document.getElementById('ifeng_share_title').innerHTML = area[languages].share.title;
    document.getElementById('ifeng_share_thumbnail').innerHTML = area[languages].share.img;
    document.getElementById('ifeng_share_description').innerHTML = area[languages].share.desc;

    return qqShareConfig?.title && isUpdate ? <QQShare content={qqShareConfig} /> : null;
};

SecondShare.propTypes = {
    languages: PropTypes.string,
};

export default errorBoundary(SecondShare);
